import {
  AvaliableDate,
  FinderDatesResponse,
  TimeDuration,
} from '@/logic/services/movie-finder';
import { Box, GridLegacy as Grid } from '@mui/material';
import { FC, useEffect } from 'react';
import { useDialog, useMovieFinder } from '@/logic/state';

import { TimeDurationItem } from './time-duration';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import DaysFilter from '@/components/movie-details/showtimes/days-filter';

interface ShowTimesProps {
  finderDates: FinderDatesResponse;
}

export const ShowTimes: FC<ShowTimesProps> = ({ finderDates: { avaliableDates } }) => {
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);
  const [
    selectedDate,
    setSelectedDate,
    setSelectedTimeDuration,
    selectedMovies,
    setSelectedMovies,
    selectedCinemas,
    setSelectedCinemas,
    selectedExperiences,
    setSelectedExperiences,
  ] = useMovieFinder(
    s => [
      s.selectedDate,
      s.setSelectedDate,
      s.setSelectedTimeDuration,
      s.selectedMovies,
      s.setSelectedMovies,
      s.selectedCinemas,
      s.setSelectedCinemas,
      s.selectedExperiences,
      s.setSelectedExperiences,
    ],
    shallow
  );

  const handleFirstEnabledDate = (date: AvaliableDate): void => {
    if (checkIfAllowedToChangeShowTimes(date.date, '')) setSelectedDate(date.date);
  };

  const selectDate = (date: string): void => {
    if (checkIfAllowedToChangeShowTimes(date, '')) setSelectedDate(date);
  };

  const handleSelectTimeDuration = (timeDuration: string): void => {
    if (checkIfAllowedToChangeShowTimes('', timeDuration))
      setSelectedTimeDuration(timeDuration);
  };

  const getTimeDurations = (): string[] => {
    const durationsList: string[] = [];
    for (const prop in TimeDuration) {
      if (Object.prototype.hasOwnProperty.call(TimeDuration, prop)) {
        durationsList.push(prop);
      }
    }
    return durationsList;
  };

  const checkIfAllowedToChangeShowTimes = (
    date?: string,
    timeDuration?: string
  ): boolean => {
    if (
      selectedMovies.length !== 0 ||
      selectedCinemas.length !== 0 ||
      selectedExperiences.length !== 0
    ) {
      setDialog({
        wrapper: true,
        isAllowedToChangeShowTimesDialog: true,
        isAllowedToChangeShowTimesDialogPayload: {
          date,
          timeDuration,
        },
      });
      return false;
    }
    return true;
  };

  const clearFilters = (): void => {
    setSelectedCinemas([]);
    setSelectedExperiences([]);
    setSelectedMovies([]);
  };

  useEffect(() => {
    if (!!!dialog?.isAllowedToChangeShowTimesDialogPayload) return;
    const { isAllowed, date, timeDuration } =
      dialog?.isAllowedToChangeShowTimesDialogPayload;
    if (isAllowed) {
      clearFilters();
      date && setSelectedDate(date);
      timeDuration && setSelectedTimeDuration(timeDuration);
      setDialog({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialog]);

  return (
    <Box>
      <DaysFilter
        sessionsDate={avaliableDates}
        showTimeDate={selectedDate}
        returnFirstEnabledDate={handleFirstEnabledDate}
        selectDate={selectDate}
      />

      <Grid
        container
        spacing={2}
        sx={{
          marginTop: pxToRem(30),
        }}
      >
        {getTimeDurations().map((element, index: number) => (
          <Grid item key={index} mobile={6} tablet={2}>
            <TimeDurationItem
              label={element}
              selectTimeDuration={handleSelectTimeDuration}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
